import { render } from "./ExportAreasDialog.vue?vue&type=template&id=6f6fa550&ts=true"
import script from "./ExportAreasDialog.vue?vue&type=script&lang=ts"
export * from "./ExportAreasDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__